import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Typography } from "@material-ui/core";
import classcat from "classcat";
import { t } from "i18next";
import { showCustomTooltip } from "infrastructure/country-rules";
import ReactTooltip from "react-tooltip";
import MealCustomText from "../benefitsTabs/customTooltipText/MealCustomText";

const getTooltipComponent = (title, country, tooltipText) => {
  if (
    title === t("benefits-section.meal-benefit.meal") &&
    showCustomTooltip(country)
  ) {
    return <MealCustomText country={country} />;
  }
  return (
    <Typography variant="body2" align="left">
      {tooltipText}
    </Typography>
  );
};

const TooltipCard = ({
  title,
  country,
  tooltipText,
  warningTooltipText = "",
  active = true,
  hasWarning = false,
}: {
  title: string;
  country: string;
  tooltipText: string;
  warningTooltipText?: string;
  active?: boolean;
  hasWarning?: boolean;
}) => {
  return (
    <span className={classcat(["benefit-tooltip", { disabled: !active }])}>
      <FontAwesomeIcon
        data-tip
        data-for={hasWarning ? `${title}-warning` : title}
        icon={hasWarning ? "exclamation-triangle" : "info-circle"}
        className={hasWarning ? "warning-icon" : undefined}
      />
      <ReactTooltip
        id={hasWarning ? `${title}-warning` : title}
        className="tooltipMessage"
        place="top"
        effect="solid"
        type="light"
      >
        {getTooltipComponent(
          title,
          country,
          hasWarning ? warningTooltipText : tooltipText
        )}
      </ReactTooltip>
    </span>
  );
};

export default TooltipCard;
